import { useAuth } from "oidc-react";
import { useExtensoToken } from "./useExtensoToken";

export function useToken(): string | undefined {
  const { userData } = useAuth();
  const { token: tokenFromExtenso } = useExtensoToken();
  return tokenFromExtenso ?? userData?.access_token;
}
